export const HEADER_RESET = 'HEADER_RESET';
export const HEADER_TOGGLE_SETTINGS = 'HEADER_TOGGLE_SETTINGS';
export const HEADER_TOGGLE_BACK_BTN = 'HEADER_TOGGLE_BACK_BTN';
export const HEADER_TOGGLE_UPDATE_BTN = 'HEADER_TOGGLE_UPDATE_BTN';
export const HEADER_TOGGLE_USER_LIFES = 'HEADER_TOGGLE_USER_LIFES';
export const HEADER_TOGGLE_TITLE = 'HEADER_TOGGLE_TITLE';
export const HEADER_BACK_BTN_CLICK = 'HEADER_BACK_BTN_CLICK';
export const HEADER_UPDATE_BTN_CLICK = 'HEADER_UPDATE_BTN_CLICK';
